import NavigationIcon from "@mui/icons-material/Navigation";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";
import L from "leaflet";
import { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { Marker } from "react-leaflet";

interface Props {
  latitude: number;
  longitude: number;
  /** Clockwise from north; null draws the vehicle as standing. */
  heading: number | null;
  stopped: boolean;
  color: string;
}

const SIZE_PX = 32;

/** The film's vehicle as on the live map: an arrow the way it drives, a square while it stands. */
export function PlaybackVehicleMarker({ latitude, longitude, heading, stopped, color }: Props) {
  const standing = stopped || heading === null;
  // Whole degrees, so the icon is not rebuilt for every hair's breadth the vehicle turns.
  const angle = standing ? 0 : Math.round(heading);
  const icon = useMemo(() => {
    const style = { color, fontSize: SIZE_PX, filter: "drop-shadow(0 0 1.5px #fff) drop-shadow(0 0 1.5px #fff)" };
    const markup = standing
      ? renderToStaticMarkup(<SquareRoundedIcon style={{ ...style, fontSize: SIZE_PX * 0.75 }} />)
      : renderToStaticMarkup(<NavigationIcon style={{ ...style, transform: `rotate(${angle}deg)` }} />);
    return L.divIcon({
      html: markup,
      className: "",
      iconSize: [SIZE_PX, SIZE_PX],
      iconAnchor: [SIZE_PX / 2, SIZE_PX / 2],
    });
  }, [angle, color, standing]);

  return <Marker position={[latitude, longitude]} icon={icon} interactive={false} />;
}
